import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNewspaper = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	className: "lucide lucide-newspaper-icon lucide-newspaper",
	"aria-hidden": "true",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M15 18h-5" }),
		/* @__PURE__ */ _jsx("path", { d: "M18 14h-8" }),
		/* @__PURE__ */ _jsx("path", { d: "M4 22h16a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v16a2 2 0 0 1-4 0v-9a2 2 0 0 1 2-2h2" }),
		/* @__PURE__ */ _jsx("rect", {
			width: 8,
			height: 4,
			x: 10,
			y: 6,
			rx: 1
		})
	]
});
export default SvgNewspaper;
